__turbopack_context__.v({
  "description": "InputDescription-module-scss-module__iW3ggG__description",
  "fade-in": "InputDescription-module-scss-module__iW3ggG__fade-in",
  "no-transform": "InputDescription-module-scss-module__iW3ggG__no-transform",
  "rotate": "InputDescription-module-scss-module__iW3ggG__rotate",
});
